var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 5H12.3824C12.5138 4.7264 12.593 4.4234 12.593 4.1C12.593 2.942 11.651 2 10.493 2C9.4604 2 8.5616 2.717 7.8914 3.4886C7.04 2.5052 6.1694 2 5.3 2C4.142 2 3.2 2.942 3.2 4.1C3.2 4.4234 3.2798 4.7264 3.4106 5H3.2C2.5382 5 2 5.5382 2 6.2V8C2 8.3318 2.2682 8.6 2.6 8.6H13.4C13.7318 8.6 14 8.3318 14 8V6.2C14 5.5382 13.4618 5 12.8 5ZM6.8348 5H5.3C4.8038 5 4.4 4.5962 4.4 4.1C4.4 3.6038 4.8038 3.2 5.3 3.2C5.8394 3.2 6.4982 3.6524 7.1552 4.4732C7.0238 4.6754 6.917 4.8542 6.8348 5ZM10.493 5H8.2496C8.8094 4.1792 9.6722 3.2 10.493 3.2C10.9892 3.2 11.393 3.6038 11.393 4.1C11.393 4.5962 10.9892 5 10.493 5Z",
    fill: "#DC3A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 9.8H7.4V14H8.6V9.8Z",
    fill: "#DC3A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 9.8H3.2V12.8C3.2 13.4618 3.7382 14 4.4 14H6.2V9.8Z",
    fill: "#DC3A3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 9.8V14H11.6C12.2618 14 12.8 13.4618 12.8 12.8V9.8H9.8Z",
    fill: "#DC3A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.48fc3dd4875b0263d371419a6fde6dda.svg";
export { ForwardRef as ReactComponent };